import { ApiRequestEnum } from 'src/app/core/enums/api-request.enum';
import { ApiService } from 'src/app/core/services/api.service';
import { Injectable } from '@angular/core';
import { CriteriaModel } from "../../shared/interfaces/CriteriaModel";
import { IItem } from "../../shared/interfaces/iitem";
import { AlertPopupService } from "../../shared/services/alert-popup.service";
import { select, Store } from "@ngrx/store";
import { CompareItems } from 'src/app/states/Item/item.actions';

const COMPARE_KEY = 'compareItems';

@Injectable({
	providedIn: 'root',
})
export class ItemService {
	constructor(
		private apiService: ApiService,
		private store: Store,
		private alertPopupService: AlertPopupService,
	) {
	}

	GetAllTypes(params) {
		return this.apiService.get(ApiRequestEnum.AGGRIGRATE_GET_ALL_TYPES, params);
	}

	GetItemsByStoreId(id: string, params?: any) {
		return this.apiService.post(ApiRequestEnum.ITEMS_BY_STORE_ID.replace('{{store_uuid}}', id), params);
	}

	GetItem(itemId: string, params?: any) {
		return this.apiService.get(ApiRequestEnum.ITEM_BY_ID.replace('{{item_uuid}}', itemId));
	}

	GetItems(params: CriteriaModel) {
		return this.apiService.post(ApiRequestEnum.ITEMS, params);
	}

	PostComment(itemId: string, params: any) {
		return this.apiService.patch(
			ApiRequestEnum.ITEM_POST_COMMENT.replace('{{item_uuid}}', itemId),
			params
		);
	}

	LikeItem(itemId: string) {
		return this.apiService.patch(
			ApiRequestEnum.ITEM_LIKE.replace('{{item_uuid}}', itemId)
		);
	}

	DisLikeItem(itemId: string, likeId: string) {
		return this.apiService.delete(
			ApiRequestEnum.ITEM_DISLIKE.replace('{{item_uuid}}', itemId).replace('{{like_uuid}}', likeId)
		);
	}

	GetCompareItems() {
		let items: any = sessionStorage.getItem(COMPARE_KEY);

		if (items) {
			items = JSON.parse(items);
		}

		return items || [];
	}

	AddItemToCompare(item: IItem): boolean {
		let items: any = this.GetCompareItems();

		if (items.length >= 3) {
			this.alertPopupService.showWarningAlert('Only 3 Items can be added to compare list');
			return false;
		}

		items.push(item);

		this.store.dispatch((
			new CompareItems({
				items: [item?.id]
			})
		))

		sessionStorage.setItem(COMPARE_KEY, JSON.stringify(items));

		this.alertPopupService.showInfoAlert('Item added to compare list');

		return true;
	}

	RemoveItemFromCompare(item: IItem): boolean {
		let items = this.GetCompareItems();

		if (!items) {
			this.alertPopupService.showInfoAlert('Item removed from compare list');
			return true;
		}

		const index = items.findIndex(i => i.id === item.id);

		if (index > -1) {
			items.splice(index, 1);
		} else {
			return false;
		}

		if (items.length) {
			sessionStorage.setItem(COMPARE_KEY, JSON.stringify(items));
		} else {
			sessionStorage.removeItem(COMPARE_KEY);
		}

		this.alertPopupService.showInfoAlert('Item removed from compare list');

		return true;
	}

	hasItemInCompareList(item: IItem): boolean {
		let items = this.GetCompareItems();

		if (!items) {
			return false;
		}

		const hasItem = !!items.find(i => i.id === item.id);

		return hasItem;
	}

	compareItems(params) {
		return this.apiService.post(ApiRequestEnum.COMPARE_ITEMS, params)
	}

	AddToCartItem(params) {
		return this.apiService.post(ApiRequestEnum.ADDTOCARTITEM, params)
	}

	GetItemFromCart() {
		return this.apiService.get(ApiRequestEnum.GETITEMFROMCART)
	}

	DeleteItemFromCart() {
		return this.apiService.delete(ApiRequestEnum.DELETEITEMFROMCART)
	}

	RemoveItemFromCart(params: any) {

		return this.apiService.delete(ApiRequestEnum.REMOVEITEMFROMCART.replace('{{variationId}}', params.variationId))
	}

	GetCheckoutData(params: any) {
		return this.apiService.post(ApiRequestEnum.GETCHECKOUTDATA, params)
	}

	phItemPaymentStatus(params: any) {
		return this.apiService.get(ApiRequestEnum.PHITEMPAYMENTSTATUS.replace('{{order_id}}', params.order_id))
	}

	GetAllCustomJewellery(params: any) {
		return this.apiService.post(ApiRequestEnum.GetAllCustomJewellery, params)
	}

	CustomJewelleryCheckOutDetail(params: any) {
		return this.apiService.post(ApiRequestEnum.CustomJewelleryCheckOutDetail, params)
	}

	CustomJewelleryPaymentStatus(order_id: string, params: any) {
		return this.apiService.post(ApiRequestEnum.CustomJewelleryPaymentStatus.replace('{{order_id}}', order_id), params)
	}

	CheckCustomJewPaymentType(itemId: string) {
		return this.apiService.get(ApiRequestEnum.CheckCustomJewPaymentType.replace('{{itemId}}', itemId))
	}

	GetReview(params) {
		return this.apiService.post(ApiRequestEnum.GetReview, params)
	}

	GetAllItemsForWeb(params) {
		return this.apiService.post(ApiRequestEnum.GetAllItemsForWeb, params)
	}

	GetStoreItemsForWeb(id: string, params?: any) {
		return this.apiService.post(ApiRequestEnum.GetStoreItemsForWeb.replace('{{store_uuid}}', id), params);
	}

	GetCustomJewelleryPriceDetails(params: any) {
		return this.apiService.post(ApiRequestEnum.GetCustomJewelleryPriceDetails, params)
	}

	GetAllCompareData(params: any) {
		return this.apiService.post(ApiRequestEnum.GetAllCompareData, params)
	}

	CheckServiceAbility(params: any) {
		return this.apiService.post(ApiRequestEnum.CheckServiceAbility, params)
	}

	CountTotalItem(storeId: string) {
		return this.apiService.get(ApiRequestEnum.CountTotalItem.replace('{{storeId}}', storeId));
	}
}
